export const DemandValidationSectionStatus = {
    OK: "OK",
    EMPTY: "EMPTY",
    ERROR: "ERROR",
    DISABLED: "DISABLED",
    UNAVAILABLE: "UNAVAILABLE"
}
